module.exports = __webpack_public_path__ + "static/media/videothumb.bbfe8acb.png";